import axios from 'axios'
import { getAuthorizationHeader, getRestApiConfig } from '../config'
import { ApiTokenPayload, ApiTokenReponse, ApiUser } from './types'

export const authorize = async (payload: ApiTokenPayload): Promise<ApiTokenReponse> => {
    const restApiConfig = getRestApiConfig()
    const tokenUrl = new URL(`api/v1/Token`, restApiConfig.baseUrl).href
    const res = await axios.post<ApiTokenReponse>(tokenUrl, { ...payload })
    return res.data
}

export const getMe = async (token?: string | null): Promise<ApiUser> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`api/v1/Users/Me`, restApiConfig.baseUrl).href
    const res = await axios.get<ApiUser>(endpointUrl, { headers: { ...getAuthorizationHeader(token) } })
    return res.data
}
